<template>
	<div
			v-if="componentView === AdvancedImageBoxComponentViewEnum.SINGLE"
			class="advanced-image-box__container advanced-image-box--one-show"
			:class="[
						slides.data.width === ComponentWidthEnum.FIX_1200 ? 'divider__fix-width' : '',
						!!slides.data.images[0]?.title || !! slides.data.images[0]?.subTitle ? 'advanced-image-box__container--gradient' : ''
					]"
			:style="{ backgroundImage: 'url(' + imagePath('path', slides.data.images[0]) + ')', minHeight: (slides.data.height ?? '300') + 'px', backgroundSize: image?.imageFit ?? ImageFitEnum.COVER }"
	>
		<img v-if="slides.data.images[0]?.icon" :src="imagePath('icon', slides.data.images[0])" alt="icon" class="advanced-image-box__icon">
		<h3 v-if="slides.data.images[0]?.title" class="advanced-image-box__title">{{ slides.data.images[0].title }}</h3>
		<p v-if="slides.data.images[0]?.subTitle" class="advanced-image-box__subtitle">{{ slides.data.images[0].subTitle }}</p>
	</div>

	<div
			v-if="componentView === AdvancedImageBoxComponentViewEnum.TILES"
			class="advanced-image-box__tiles-container"
			:class="slides.data.width === ComponentWidthEnum.FIX_1200 ? 'divider__fix-width' : ''"
	>
		<div class="advanced-image-box__tiles">
			<div
					v-for="(image, index) in slides.data.images"
					class="advanced-image-box__tile"
					:key="index"
					:class="!!image?.title || !! image?.subTitle ? 'advanced-image-box__container--gradient' : ''"
					:style="{ backgroundImage: 'url(' + imagePath('path', image) + ')', backgroundSize: image?.imageFit ?? ImageFitEnum.COVER, minHeight: (slides.data.height ?? '300' )+ 'px'}"
			>
				<img v-if="image?.icon" :src="imagePath('icon', image)" alt="icon" class="advanced-image-box__icon">
				<h3 v-if="image?.title" class="advanced-image-box__title">{{ image.title }}</h3>
				<p v-if="image?.subTitle" class="advanced-image-box__subtitle">{{ image.subTitle }}</p>
			</div>
		</div>
	</div>

	<swiper
			v-if="componentView === AdvancedImageBoxComponentViewEnum.SWIPER"
			class="advanced-image-box__swiper"
			:class="slides.data.width === ComponentWidthEnum.FIX_1200 ? 'divider__fix-width' : ''"
			:modules="modules"
			:breakpoints="breakpoints"
			:slidesPerView="3"
			:spaceBetween="16"
			:navigation="true"
	>
		<swiper-slide v-for="(image, index) in slides.data.images" :key="index">
			<div
					class="advanced-image-box__container"
					:class="[
								slides.data.layout === '1' ? 'advanced-image-box--one-show' : '',
								!!image?.title || !! image?.subTitle ? 'advanced-image-box__container--gradient' : '',
							]"
					:style="{ backgroundImage: 'url(' + imagePath('path', image) + ')', backgroundSize: image?.imageFit ?? ImageFitEnum.COVER, minHeight: (slides.data.height ?? '300' )+ 'px' }"
			>
				<img v-if="image?.icon" :src="imagePath('icon', image)" alt="icon" class="advanced-image-box__icon">
				<h3 v-if="image?.title" class="advanced-image-box__title">{{ image.title }}</h3>
				<p v-if="image?.subTitle" class="advanced-image-box__subtitle">{{ image.subTitle }}</p>
			</div>
		</swiper-slide>
	</swiper>
</template>

<style scoped lang="scss">
@media (min-width: 1439px) {
	.advanced-image-box__container, .advanced-image-box__tile {
		width: 100%;
	}
}
</style>

<script setup lang="ts">
import {Swiper, SwiperSlide} from 'swiper/vue';
import {Autoplay, Navigation, Pagination} from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import {computed, defineProps, PropType} from "vue";
import {IAdvancedImageBoxComponent} from "@SharedInterfaces/IAdvancedImageBoxComponent";
import {ComponentWidthEnum} from "@SharedEnums/ComponentWidthEnum";
import {AdvancedImageBoxComponentViewEnum} from "../Enums/AdvancedImageBoxComponentViewEnum";
import {ImageFitEnum} from "../../../../Shared/Enums/ImageFitEnum";

const props = defineProps({
	slides: {
		type: Object as PropType<IAdvancedImageBoxComponent>,
		default: {},
		required: true,
	},
});


const modules = [
	Autoplay,
	Navigation,
	Pagination
];
const breakpoints = computed(() => {
	return {
		'1440': {
			slidesPerView: props.slides.data.layout,
			spaceBetween: 20,
		},
	}
});
const componentView = computed(() => {
	if (props.slides.data.layout === '1' && props.slides.data.images.length === 1) {
		return AdvancedImageBoxComponentViewEnum.SINGLE;
	} else if (props.slides.data.layout === '3' && props.slides.data.images.length === 3) {
		return AdvancedImageBoxComponentViewEnum.TILES;
	} else {
		return AdvancedImageBoxComponentViewEnum.SWIPER;
	}
});


const imagePath = (property, image) => {
	return image[property]?.webp ?? image[property];
};
</script>
